import axios from 'axios'
import Loading from 'vue-loading-overlay'
import PaginationNav from '../../components/PaginationNav.vue'
import PaginationMobile from '../../components/PaginationMobile.vue'
import moment from 'moment'
import LoadingComp from '../../components/LoadingComp.vue'
import StoreCardSkeleton from '../../components/StoreCardSkeleton.vue'
import WhatsappContacts from '../../components/WhatsappContacts.vue'
import WelcomeModal from '../../components/WelcomeModal.vue'

import * as config from '@/config.json'
import * as helpers from '../../helpers/object-helper'

export default {
  name: 'HomeComp',

  components: {
    Loading,
    PaginationNav,
    PaginationMobile,
    LoadingComp,
    StoreCardSkeleton,
    WhatsappContacts,
    WelcomeModal
  },

  data: () => {
    return {
      helperUrlImage: helpers.UrlImage.NO_IMAGE.url,
      isLoading: false,
      loader: 'bars',
      opacity: 0.8,
      token: null,
      dataDashboard: [],
      currentStorePage: 1,
      storesPerPage: 4,
      storesPerPageOptions: [
        { value: 4, text: '4 lojas' },
        { value: 8, text: '8 lojas' },
        { value: 12, text: '12 lojas' },
        { value: 16, text: '16 lojas' },
        { value: 20, text: '20 lojas' },
        { value: 24, text: '24 lojas' },
        { value: 28, text: '28 lojas' },
        { value: 32, text: '32 lojas' }
      ],

      siteSearchTerm: '',
      companySearchTerm: '',
      filteredStores: [],

      storeSortOption: 'highest_sales_period',
      storeSortOptions: [
        { value: 'site_offline', text: 'Loja Offline' },
        { value: 'site_online', text: 'Loja Online' },
        { value: 'server_offline', text: 'Servidor Local Offline' },
        { value: 'server_online', text: 'Servidor Local Online' },
        { value: 'highest_sales_period', text: 'Maior Venda Hoje' },
        { value: 'lowest_sales_period', text: 'Menor Venda Hoje' }
      ],

      tabIndex: 0,

      isSendingPending: false,
      pendingProgress: 0,
      pendingStartTime: null,
      pendingElapsedTime: 0,
      pendingStatus: '',
      pendingOperation: '',
      pendingTimer: null,
      pendingOperations: {
        orders: false,
        stock: false,
        customers: false,
        all: false
      },

      paramsOrders: [],
      currentPage: 1,
      perPage: 10,
      pagination: {},
      paginationRange: 11,
      selectedPeriod: null,
      currentPeriod: 'today',
      storePeriods: {},
      totalOrders: [],
      amountOrdersToday: null,
      valueOrdersToday: null,
      averageTicketToday: null,
      amountOrdersSevenDays: null,
      valueOrdersSevenDays: null,
      averageTicketSevenDays: null,
      amountOrdersThirtyDays: null,
      valueOrdersThirtyDays: null,
      averageTicketThirtyDays: null,
      period: [
        {
          value: 0,
          text: 'Hoje'
        },
        {
          value: 7,
          text: '7 Dias'
        },
        {
          value: 30,
          text: '30 Dias'
        }
      ],
      items: [],
      fields: [
        {
          key: 'position',
          label: 'Posição'
        },
        {
          key: 'imageUrl',
          label: 'Imagem'
        },
        {
          key: 'sku',
          label: 'Barras'
        },
        {
          key: 'description',
          label: 'Descrição'
        },
        {
          key: 'quantity',
          label: 'Quantidade'
        },
        {
          key: 'totalValue',
          label: 'Valor Total'
        }
      ],
      fieldsMobile: [
        {
          key: 'position',
          label: 'Posição'
        },
        {
          key: 'sku',
          label: 'Barras'
        },
        {
          key: 'description',
          label: 'Descrição'
        },
        {
          key: 'quantity',
          label: 'Quantidade'
        },
        {
          key: 'totalValue',
          label: 'Valor Total'
        }
      ],

      periodSearch: null,
      chartOptionsOrdersByGroup: {},
      labelsGroup: [],
      seriesGroup: [],

      chartOptions: {
        chart: {
          height: 500,
          width: 700,
          type: 'bar',
          background: '#fff',

          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,

            animateGradually: {
              enabled: true,
              delay: 150
            },

            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          }
        },

        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val > 0 ? val.toFixed(2) : 0
          },
          style: {
            colors: ['#333'],
            fontSize: '12px',
            fontWeight: 'normal'
          },
          offsetY: 5,

          dropShadow: {
            color: '#111',
            blur: 3,
            opacity: 0.8
          }
        },

        plotOptions: {
          bar: {
            columnWidth: '50%',
            borderRadius: 5,
            dataLabels: {
              position: 'top',
              orientation: 'vertical'
            }
          }
        }
      },
      series: [
        {
          name: 'Vendas',
          data: []
        }
      ],

      xaxis: {
        type: 'datetime'
      },

      posBySite: [],
      productsSite: [],
      paginationProductsSite: {},
      paginationRangeProductsSite: 11,
      perPageProductsSite: 10,
      currentPageProductsSite: 1,
      companiesToWebhooks: [],
      selectMode: 'multi',
      selectedCompanies: [],
      selectedPartners: [],
      companiesId: [],
      companiesIdPartners: [],
      companiesPartnersPending: [],
      totalPartnersPending: 0,
      totalOrdersNotSent: 0,
      totalPending: 0,
      allPartnersPending: 0,
      ordersNotSent: [],
      fieldsOrdersNotSent: [
        {
          key: 'selected',
          label: 'Selecionar'
        },
        {
          key: 'companyName',
          label: 'Empresa'
        },
        {
          key: 'siteId',
          label: 'Loja'
        },
        {
          key: 'pendingRecords',
          label: 'Pendências'
        },
        {
          key: 'isOnline',
          label: 'Status'
        }
      ],
      fieldsPartnersPending: [
        {
          key: 'selected',
          label: 'Selecionar'
        },
        {
          key: 'partnerName',
          label: 'Empresa'
        },
        {
          key: 'counter',
          label: 'Pendências'
        }
      ],
      fieldsPartnersCustomerPending: [
        {
          key: 'selected',
          label: 'Selecionar'
        },
        {
          key: 'partnerName',
          label: 'Empresa'
        },
        {
          key: 'counter',
          label: 'Pendências'
        }
      ],
      messageSendOrders: '',
      userPermissions: [],
      isBusy: false,
      isBusyCharts: false,
      isBusyDashboards: false,
      isLoadingInitial: true,
      loadingProgress: 0,
      loadingSteps: ['dashboard', 'charts', 'products', 'partners'],
      currentLoadingStep: 0,
      initialLoadingMessage: 'Carregando',
      initialLoadingSubtext: '',
      dashboardsLoadingMessage: '',
      dashboardsLoadingSubtext: '',
      chartsLoadingMessage: '',
      chartsLoadingSubtext: '',
      productsLoadingMessage: '',
      productsLoadingSubtext: '',
      partnersLoadingMessage: '',
      partnersLoadingSubtext: '',
      isVerifyingPartners: false,
      isVerifyingPartnersCustomer: false,
      partnersCustomerLoadingMessage: '',
      partnersCustomerLoadingSubtext: '',
      partnersTabIndex: 0,
      companiesPartnersCustomerPending: [],
      totalPartnersCustomerPending: 0,
      selectedPartnersCustomer: [],
      companiesIdPartnersCustomer: [],
      showNotificationsRibbon: false,
      isFiltersOpen: false,
      isFiltersMobileOpen: false,
      permissions: []
    }
  },

  methods: {
    openModalSafely(modalId, refName, action = 'show', attempts = 0) {
      try {
        const maxAttempts = 10
        const delayMs = 80

        this.$nextTick(() => {
          try {
            const refModal = this.$refs && this.$refs[refName]
            if (refModal && typeof refModal[action] === 'function') {
              refModal[action]()
              return
            }

            if (this.$bvModal && typeof this.$bvModal[action] === 'function') {
              this.$bvModal[action](modalId)
              return
            }

            if (attempts < maxAttempts) {
              setTimeout(() => {
                this.openModalSafely(modalId, refName, action, attempts + 1)
              }, delayMs)
            }
          } catch (err) {
            if (attempts < 10) {
              setTimeout(() => {
                this.openModalSafely(modalId, refName, action, attempts + 1)
              }, 80)
            }
          }
        })
      } catch (e) {
        // noop
      }
    },
    publishPosOfflineCount() {
      try {
        const offlineCount = Array.isArray(this.dataDashboard)
          ? this.dataDashboard.filter(site => {
              if (!site || !('isError' in site)) return false
              const status = String(site.isError)
              return status !== '0' && status !== '1' && status !== '-2'
            }).length
          : 0

        localStorage.setItem('posOfflineCount', String(offlineCount))
        if (typeof window !== 'undefined' && window.dispatchEvent) {
          window.dispatchEvent(new CustomEvent('pos-offline-count', { detail: offlineCount }))
        }
      } catch (e) {
        console.error('Erro ao publicar contagem de POS offline:', e)
      }
    },

    dismissNotificationsRibbon() {
      this.showNotificationsRibbon = false
      sessionStorage.setItem('homeNotificationsRibbonDismissed', '1')
      sessionStorage.setItem('homeNotificationsHintShown', '1')
    },

    openNotificationsFromRibbon() {
      this.dismissNotificationsRibbon()
      if (typeof window !== 'undefined' && window.dispatchEvent) {
        window.dispatchEvent(new CustomEvent('navbar-open-notifications'))
      }
    },

    publishTotalPendingCount() {
      try {
        const total = Number(this.totalPending || 0)
        localStorage.setItem('totalPendingCount', String(total))
        if (typeof window !== 'undefined' && window.dispatchEvent) {
          window.dispatchEvent(new CustomEvent('home-total-pending', { detail: total }))
        }
      } catch (e) {
        console.error('Erro ao publicar contagem de pendências:', e)
      }
    },

    publishLocalServerOfflineCount() {
      try {
        const localOffline = Array.isArray(this.dataDashboard)
          ? this.dataDashboard.filter(site => site && site.isPandoraLocalOnline === false).length
          : 0

        localStorage.setItem('localServerOfflineCount', String(localOffline))
        if (typeof window !== 'undefined' && window.dispatchEvent) {
          window.dispatchEvent(new CustomEvent('home-local-server-offline', { detail: localOffline }))
        }
      } catch (e) {
        console.error('Erro ao publicar contagem de servidor local offline:', e)
      }
    },

    async showInitialNotificationsHint() {
      try {
        const alreadyNotified = sessionStorage.getItem('homeNotificationsHintShown') === '1'
        if (alreadyNotified) return

        const posOffline = Array.isArray(this.dataDashboard)
          ? this.dataDashboard.filter(site => {
              if (!site || !('isError' in site)) return false
              const status = String(site.isError)
              return status !== '0' && status !== '1' && status !== '-2'
            }).length
          : 0

        const localOffline = Array.isArray(this.dataDashboard)
          ? this.dataDashboard.filter(site => site && site.isPandoraLocalOnline === false).length
          : 0

        const hasPend = Number(this.totalPending || 0) > 0
        const hasPos = posOffline > 0
        const hasLocal = localOffline > 0

        if (hasPend || hasPos || hasLocal) {
          if (typeof window !== 'undefined' && window.dispatchEvent) {
            window.dispatchEvent(new CustomEvent('navbar-bell-hint'))
          }
          try {
            localStorage.setItem('navbarBellHint', '1')
          } catch (err) {
            // noop
          }
          sessionStorage.setItem('homeNotificationsHintShown', '1')
        }
      } catch (e) {
        // noop
      }
    },
    selectAllRows() {
      if (this.$refs.selectableCompanies && typeof this.$refs.selectableCompanies.selectAllRows === 'function') {
        this.$refs.selectableCompanies.selectAllRows()
      }
    },
    clearSelected() {
      this.$refs.selectableCompanies.clearSelected()
    },

    selectAllRowsPartners() {
      if (this.$refs.selectableCompaniesPartners && typeof this.$refs.selectableCompaniesPartners.selectAllRows === 'function') {
        this.$refs.selectableCompaniesPartners.selectAllRows()
      }
    },

    clearSelectedPartners() {
      this.$refs.selectableCompaniesPartners.clearSelected()
    },

    async fillModels() {
      this.posBySite.forEach(item => {
        item.varSitefLib = item.sitefLib
        item.varSitefParams = item.sitefParams
        item.varSitefOtp = item.sitefOtp
        item.varSitefAllowedTransactions = item.sitefAllowedTransactions
        item.varSitefTimerInteraction = item.timerInteraction
      })
    },

    async getNotification(title, body, type) {
      this.$vToastify.setSettings({
        position: 'bottom-center'
      })
      await this.$vtNotify({
        title: title,
        body: body,
        type: type,
        duration: 3000
      })
    },

    async showModalTotens() {
      this.tabIndex = 0
      if (this.posBySite.length > 0) {
        await this.$bvModal.show('rebootPOS')
      } else {
        this.getNotification('Aviso', `Nenhum Totem configurado para o site selecionado!`, 'warning')
      }
    },

    async buildParamsGetPos(companyId, siteId, deviceId, deviceName) {
      const params = {
        companyId,
        siteId,
        deviceId,
        deviceName,
        page: 1,
        pageSize: 10
      }
      return params
    },

    showPassword() {
      let typeUserPassword = document.getElementById('inputPassword')

      if (typeUserPassword.type == 'text') {
        typeUserPassword.type = 'password'
      } else {
        typeUserPassword.type = 'text'
      }

      this.showUserPassword = !this.showUserPassword
    },

    async getDevicesBySiteId(site) {
      this.$router.push({
        name: 'DevicesList',
        params: {
          companyId: site.companyId,
          siteId: site.siteId
        }
      })
    },

    openLocalServer(site) {
      if (!site.isPandoraLocalOnline) {
        this.$alert('Servidor local está offline!', 'Aviso', 'warning')
        return
      }

      let localServerUrl = this.buildLocalServerUrl(site)

      if (localServerUrl) {
        window.open(localServerUrl, '_blank')
      } else {
        this.$alert('URL do servidor local não configurada para esta loja!', 'Aviso', 'warning')
      }
    },

    buildLocalServerUrl(site) {
      if (site.pandoraLocalApiHealthCheckApi) {
        return site.pandoraLocalApiHealthCheckApi
      }

      return null
    },

    async buildParamsOrder(companyId, siteId, selectedOption, startDate, endDate) {
      this.paramsOrders = {
        companyId,
        siteId,
        selectedOption,
        startDate,
        endDate
      }
    },

    navigate(page) {
      this.getTopOrderedProducts(page, this.periodSearch)
    },

    filterStores() {
      if (!this.dataDashboard || this.dataDashboard.length === 0) {
        this.filteredStores = []
        return
      }

      if (!this.siteSearchTerm && !this.companySearchTerm) {
        this.filteredStores = [...this.dataDashboard]
      } else {
        this.filteredStores = this.dataDashboard.filter(store => {
          const siteIdStr = String(store.siteId || '')
          const fantasyStr = String(store.fantasy || '')
          const companyNameStr = String(store.companyName || '')

          let siteMatch = true
          if (this.siteSearchTerm && this.siteSearchTerm.trim()) {
            const searchTerm = this.siteSearchTerm.toLowerCase().trim()
            siteMatch = (siteIdStr && siteIdStr.toLowerCase().includes(searchTerm)) || (fantasyStr && fantasyStr.toLowerCase().includes(searchTerm))
          }

          let companyMatch = true
          if (this.companySearchTerm && this.companySearchTerm.trim()) {
            const searchTerm = this.companySearchTerm.toLowerCase().trim()
            companyMatch = companyNameStr && companyNameStr.toLowerCase().includes(searchTerm)
          }

          return siteMatch && companyMatch
        })
      }

      this.applySorting()

      this.currentStorePage = 1
    },

    clearSearch() {
      this.siteSearchTerm = ''
      this.companySearchTerm = ''
      this.storeSortOption = 'site_offline'
      this.filteredStores = [...this.dataDashboard]
      this.applySorting()
      this.currentStorePage = 1
    },

    clearSiteSearch() {
      this.siteSearchTerm = ''
      this.filterStores()
    },

    clearCompanySearch() {
      this.companySearchTerm = ''
      this.filterStores()
    },

    onStoresPerPageChange() {
      this.currentStorePage = 1
    },

    applyStoreSorting() {
      this.currentStorePage = 1
      this.filterStores()
    },
    applySorting() {
      if (!this.filteredStores || this.filteredStores.length === 0) {
        return
      }

      const storesToSort = [...this.filteredStores]

      switch (this.storeSortOption) {
        case 'site_offline':
          // Ordenação: Offline > Alerta > Online > Indisponível
          storesToSort.sort((a, b) => {
            // Centros de distribuição sempre por último
            if (a.isDistributionCenter && !b.isDistributionCenter) return 1
            if (b.isDistributionCenter && !a.isDistributionCenter) return -1
            if (a.isDistributionCenter && b.isDistributionCenter) return 0

            // Converter para número para garantir comparação correta
            const errorA = Number(a.isError)
            const errorB = Number(b.isError)
            const isValidStatusA = errorA === 0 || errorA === 1 || errorA === -1
            const isValidStatusB = errorB === 0 || errorB === 1 || errorB === -1

            // Se ambos são indisponíveis, manter ordem original
            if (errorA === -2 && errorB === -2) return 0

            // Lojas indisponíveis sempre por último
            if (errorA === -2) return 1
            if (errorB === -2) return -1

            // Se ambos têm status válido, ordenar por prioridade: Offline > Alerta > Online
            if (isValidStatusA && isValidStatusB) {
              const statusA = errorA
              const statusB = errorB

              // 1º: Lojas Offline (isError == -1)
              if (statusA === -1 && (statusB === 0 || statusB === 1)) return -1
              if (statusB === -1 && (statusA === 0 || statusA === 1)) return 1

              // 2º: Lojas em Alerta (isError == 1)
              if (statusA === 1 && statusB === 0) return -1
              if (statusB === 1 && statusA === 0) return 1

              // 3º: Lojas Online (isError == 0)
              return 0
            }

            // Se apenas uma tem status válido, priorizar a que tem status válido
            // Se ambas são indisponíveis, manter ordem original para estabilidade
            if (!isValidStatusA && !isValidStatusB) return 0
            return isValidStatusA ? -1 : 1
          })
          break

        case 'site_online':
          // Ordenação: Online > Alerta > Offline > Indisponível
          storesToSort.sort((a, b) => {
            // Centros de distribuição sempre por último
            if (a.isDistributionCenter && !b.isDistributionCenter) return 1
            if (b.isDistributionCenter && !a.isDistributionCenter) return -1
            if (a.isDistributionCenter && b.isDistributionCenter) return 0

            // Converter para número para garantir comparação correta
            const errorA = Number(a.isError)
            const errorB = Number(b.isError)
            const isValidStatusA = errorA === 0 || errorA === 1 || errorA === -1
            const isValidStatusB = errorB === 0 || errorB === 1 || errorB === -1

            // Se ambos são indisponíveis, manter ordem original
            if (errorA === -2 && errorB === -2) return 0

            // Lojas indisponíveis sempre por último
            if (errorA === -2) return 1
            if (errorB === -2) return -1

            // Se ambos têm status válido, ordenar por prioridade: Online > Alerta > Offline
            if (isValidStatusA && isValidStatusB) {
              const statusA = errorA
              const statusB = errorB

              // 1º: Lojas Online (isError == 0)
              if (statusA === 0 && statusB !== 0) return -1
              if (statusB === 0 && statusA !== 0) return 1

              // 2º: Lojas em Alerta (isError == 1)
              if (statusA === 1 && statusB !== 0 && statusB !== 1) return -1
              if (statusB === 1 && statusA !== 0 && statusA !== 1) return 1

              // 3º: Lojas Offline (isError == -1)
              if (statusA === -1 && (statusB === 0 || statusB === 1)) return 1
              if (statusB === -1 && (statusA === 0 || statusA === 1)) return -1

              return 0
            }

            // Se apenas uma tem status válido, priorizar a que tem status válido
            return isValidStatusA ? -1 : 1
          })
          break

        case 'server_offline':
          storesToSort.sort((a, b) => {
            if (a.isDistributionCenter && !b.isDistributionCenter) return 1
            if (b.isDistributionCenter && !a.isDistributionCenter) return -1
            if (a.isDistributionCenter && b.isDistributionCenter) return 0

            const rank = v => (v === false ? 0 : v === true ? 1 : 2)
            const rankA = rank(a.isPandoraLocalOnline)
            const rankB = rank(b.isPandoraLocalOnline)
            if (rankA !== rankB) return rankA - rankB

            const errorA = Number(a.isError)
            const errorB = Number(b.isError)
            const isValidA = errorA === 0 || errorA === 1 || errorA === -1
            const isValidB = errorB === 0 || errorB === 1 || errorB === -1
            if (errorA === -2 && errorB === -2) return 0
            if (errorA === -2) return 1
            if (errorB === -2) return -1
            if (isValidA && isValidB) {
              if (errorA === -1 && (errorB === 0 || errorB === 1)) return -1
              if (errorB === -1 && (errorA === 0 || errorA === 1)) return 1
              if (errorA === 1 && errorB === 0) return -1
              if (errorB === 1 && errorA === 0) return 1
              return 0
            }
            if (!isValidA && !isValidB) return 0
            return isValidA ? -1 : 1
          })
          break

        case 'server_online':
          storesToSort.sort((a, b) => {
            if (a.isDistributionCenter && !b.isDistributionCenter) return 1
            if (b.isDistributionCenter && !a.isDistributionCenter) return -1
            if (a.isDistributionCenter && b.isDistributionCenter) return 0

            const rank = v => (v === true ? 0 : v === false ? 1 : 2)
            const rankA = rank(a.isPandoraLocalOnline)
            const rankB = rank(b.isPandoraLocalOnline)
            if (rankA !== rankB) return rankA - rankB

            const errorA = Number(a.isError)
            const errorB = Number(b.isError)
            const isValidA = errorA === 0 || errorA === 1 || errorA === -1
            const isValidB = errorB === 0 || errorB === 1 || errorB === -1
            if (errorA === -2 && errorB === -2) return 0
            if (errorA === -2) return 1
            if (errorB === -2) return -1
            if (isValidA && isValidB) {
              if (errorA === 0 && errorB !== 0) return -1
              if (errorB === 0 && errorA !== 0) return 1
              if (errorA === 1 && errorB === -1) return -1
              if (errorB === 1 && errorA === -1) return 1
              return 0
            }
            if (!isValidA && !isValidB) return 0
            return isValidA ? -1 : 1
          })
          break

        case 'highest_sales_period':
          // Ordenação: Maior venda primeiro, depois por status
          storesToSort.sort((a, b) => {
            // Primeiro ordenar por vendas (maior prioridade)
            let salesA, salesB
            const parseCurrency = value => {
              if (value === null || value === undefined) return 0
              if (typeof value === 'number') return value
              const normalized = value.toString().replace(/\s/g, '').replace('R$', '').replace(/\./g, '').replace(',', '.')
              const num = parseFloat(normalized)
              return isNaN(num) ? 0 : num
            }

            if (this.currentPeriod === '7days') {
              salesA = parseCurrency(a.valueOrdersSevenDays)
              salesB = parseCurrency(b.valueOrdersSevenDays)
            } else if (this.currentPeriod === '30days') {
              salesA = parseCurrency(a.valueOrdersThirtyDays)
              salesB = parseCurrency(b.valueOrdersThirtyDays)
            } else {
              salesA = parseCurrency(a.valueOrdersToday)
              salesB = parseCurrency(b.valueOrdersToday)
            }

            // Se as vendas são diferentes, ordenar por vendas
            if (salesA !== salesB) {
              return salesB - salesA
            }

            // Se as vendas são iguais, então considerar o status
            const hasStatusA = 'isError' in a
            const hasStatusB = 'isError' in b

            // Se ambos são indisponíveis, manter ordem original
            if (!hasStatusA && !hasStatusB) return 0

            // Lojas indisponíveis por último quando vendas são iguais
            if (!hasStatusA) return 1
            if (!hasStatusB) return -1

            // Se ambos têm status, manter ordem original
            return 0
          })
          break

        case 'lowest_sales_period':
          // Ordenação: Menor venda primeiro, depois por status
          storesToSort.sort((a, b) => {
            // Primeiro ordenar por vendas (maior prioridade)
            let salesA, salesB
            const parseCurrency = value => {
              if (value === null || value === undefined) return 0
              if (typeof value === 'number') return value
              const normalized = value.toString().replace(/\s/g, '').replace('R$', '').replace(/\./g, '').replace(',', '.')
              const num = parseFloat(normalized)
              return isNaN(num) ? 0 : num
            }

            if (this.currentPeriod === '7days') {
              salesA = parseCurrency(a.valueOrdersSevenDays)
              salesB = parseCurrency(b.valueOrdersSevenDays)
            } else if (this.currentPeriod === '30days') {
              salesA = parseCurrency(a.valueOrdersThirtyDays)
              salesB = parseCurrency(b.valueOrdersThirtyDays)
            } else {
              salesA = parseCurrency(a.valueOrdersToday)
              salesB = parseCurrency(b.valueOrdersToday)
            }

            // Se as vendas são diferentes, ordenar por vendas
            if (salesA !== salesB) {
              return salesA - salesB
            }

            // Se as vendas são iguais, então considerar o status
            const hasStatusA = a.isError !== undefined && a.isError !== null
            const hasStatusB = b.isError !== undefined && b.isError !== null

            // Se ambos são indisponíveis, manter ordem original
            if (!hasStatusA && !hasStatusB) return 0

            // Lojas indisponíveis por último quando vendas são iguais
            if (!hasStatusA) return 1
            if (!hasStatusB) return -1

            // Se ambos têm status, manter ordem original
            return 0
          })
          break

        default:
          break
      }

      this.filteredStores = storesToSort

      this.updatePeriodsAfterSorting()
    },

    async buildDataCommand(deviceType, deviceId, command) {
      let data = new Object()

      if (deviceType == 'pos') {
        data.deviceId = deviceId
      } else if (deviceType == 'recognitionDevices') {
        data.recognitionDeviceId = deviceId
      }
      data.command = command

      return data
    },

    async commandPOS(deviceType, device, command) {
      this.isLoading = true
      let url = ''

      if (deviceType == 'pos') {
        url = `${config.default.urlBaseCustomer}/sites/pos/command`
      } else if (deviceType == 'recognitionDevices') {
        url = `${config.default.urlBaseCustomer}/sites/recognition-devices/command`
      }

      const data = await this.buildDataCommand(deviceType, device.id, command)

      try {
        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          await this.getNotification('Aviso', 'Comando enviado com sucesso!', 'success')

          await this.$bvModal.hide('rebootPOS')
        }
      } catch (error) {
        console.error('Error in commandPOS:', error)

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        await this.$alert(`Não foi possivel executar o comando! ${error.response.data.message}`, 'Aviso', 'warning')
      }
    },

    async getOrders(item) {
      const startDate = moment(new Date()).format('YYYY-MM-DD')
      const endDate = moment(new Date()).format('YYYY-MM-DD')

      await this.buildParamsOrder(item.companyId, item.siteId, 2, startDate, endDate)
      this.$router.push({
        name: 'SalesList',
        params: this.paramsOrders
      })
    },

    buildParams(pagina, period) {
      let params = new Object()

      params.pageSize = this.perPage
      params.page = pagina
      params.period = period

      return params
    },

    buildParamsChart(period, pagina) {
      let params = new Object()

      params.period = period

      params.pageSize = this.perPage
      params.page = pagina

      return params
    },

    async loadAllDataParallel() {
      try {
        this.isLoadingInitial = true
        this.loadingProgress = 0
        this.currentLoadingStep = 0

        this.initialLoadingMessage = 'Buscando Lojas'
        this.initialLoadingSubtext = 'Coletando status dos servidores locais...'
        try {
          await this.getDashboard()
          this.updateLoadingProgress('dashboard')
        } catch (e) {
          console.error('Erro ao carregar dashboards:', e)
        }

        this.initialLoadingMessage = 'Buscando Vendas por Período'
        this.initialLoadingSubtext = 'Consultando a API de vendas e grupos...'
        try {
          await this.getDataChart(this.getPeriodValueForChart(this.currentPeriod))
          this.updateLoadingProgress('charts')
        } catch (e) {
          console.error('Erro ao carregar gráficos:', e)
        }

        this.initialLoadingMessage = 'Buscando Top Produtos'
        this.initialLoadingSubtext = 'Montando a lista de mais vendidos...'
        try {
          await this.getTopOrderedProducts(this.currentPage, this.currentPeriod)
          this.updateLoadingProgress('products')
        } catch (e) {
          console.error('Erro ao carregar top produtos:', e)
        }

        this.initialLoadingMessage = 'Buscando Pendências Locais'
        this.initialLoadingSubtext = 'Verificando pendências de estoque...'
        try {
          await this.verifyPartnersPending()
          await this.verifyPartnersCustomerPending()
          this.updateLoadingProgress('partners')
        } catch (e) {
          console.error('Erro ao verificar pendências de parceiros:', e)
        }

        await this.calculateTotalOrdersNotSent(this.totalOrdersNotSent, this.totalPartnersPending, this.totalPartnersCustomerPending)

        this.loadingProgress = 100
        this.isLoadingInitial = false

        await this.$nextTick()
        this.$forceUpdate()
      } catch (error) {
        console.error('Erro durante carregamento sequencial:', error)
        this.isLoadingInitial = false
      }
    },

    updateLoadingProgress(step) {
      const stepIndex = this.loadingSteps.indexOf(step)
      if (stepIndex !== -1) {
        this.currentLoadingStep = stepIndex
        this.loadingProgress = ((stepIndex + 1) / this.loadingSteps.length) * 100
      }

      switch (step) {
        case 'dashboard':
          this.initialLoadingMessage = 'Buscando Lojas'
          this.initialLoadingSubtext = 'Coletando status dos servidores locais...'
          break
        case 'charts':
          this.initialLoadingMessage = 'Buscando Vendas por Período'
          this.initialLoadingSubtext = 'Consultando a API de vendas e grupos...'
          break
        case 'products':
          this.initialLoadingMessage = 'Buscando Top Produtos'
          this.initialLoadingSubtext = 'Montando a lista de mais vendidos...'
          break
        case 'partners':
          this.initialLoadingMessage = 'Buscando Pendências Locais'
          this.initialLoadingSubtext = 'Verificando pendências de estoque...'
          break
        default:
          this.initialLoadingMessage = 'Carregando'
          this.initialLoadingSubtext = 'Aguarde, preparando tudo...'
      }
    },

    handleApiError(error) {
      if (!error.response) {
        this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
      } else if (error.response.status === 401) {
        this.$alert('Sessão expirada. Faça login novamente.', 'Erro', 'error')
      } else if (error.response.status === 500) {
        this.$alert('Erro interno do servidor. Tente novamente mais tarde.', 'Erro', 'error')
      }
    },

    async getDataChart(period) {
      if (this.periodSearch === period) {
        return
      }

      this.periodSearch = period
      this.updateLoadingProgress('charts')
      await this.updateHome(this.currentPage, period)
    },

    async updateChart(period) {
      if (this.isBusyCharts) {
        return
      }

      const url = `${config.default.urlBase}/dashboards/landing-page/orders/search`
      const params = this.buildParamsChart(period, this.currentPage)

      this.isBusyCharts = true
      this.chartsLoadingMessage = 'Buscando Vendas por Período'
      this.chartsLoadingSubtext = 'Consultando a API de vendas e grupos...'

      try {
        const response = await axios({
          url,
          method: 'GET',
          params: params,
          headers: {
            authorization: `Bearer ${this.token}`
          },
          timeout: 20000 // Timeout de 20 segundos
        })

        this.series = []
        this.seriesGroup = []

        if (response.status == 200) {
          this.series = [
            {
              name: 'Vendas',
              data: response.data.seriesMounted || []
            }
          ]

          this.seriesGroup = response.data.seriesByGroupMounted?.seriesGroup || []
          this.labelsGroup = response.data.seriesByGroupMounted?.labelsGroup || []

          this.updateChartOptions()

          this.chartsLoadingMessage = 'Montando Gráficos'
          this.chartsLoadingSubtext = 'Renderizando visualizações...'
        }
      } catch (error) {
        console.error('Error in updateChart:', error)
        this.handleApiError(error)
        this.series = []
        this.seriesGroup = []
      } finally {
        this.isBusyCharts = false
        this.chartsLoadingMessage = ''
        this.chartsLoadingSubtext = ''
      }
    },

    updateChartOptions() {
      const newChartOptionsOrdersByGroup = {
        chart: {
          width: 450,
          height: 360,
          type: 'donut',
          dropShadow: {
            enabled: true,
            color: '#111',
            top: -1,
            left: 3,
            blur: 3,
            opacity: 0.2
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          }
        },
        stroke: {
          width: 0
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
            donut: {
              size: 60,
              labels: {
                show: true,
                total: {
                  showAlways: true,
                  show: true,
                  formatter: function (w) {
                    return parseFloat(
                      w.globals.seriesTotals
                        .reduce((a, b) => {
                          return a + b
                        }, 0)
                        .toFixed(2)
                    )
                  }
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val.toFixed(2) + '%'
          },
          dropShadow: {
            blur: 3,
            opacity: 0.8
          }
        },
        legend: {
          position: 'bottom'
        },
        fill: {
          type: 'gradient'
        },
        theme: {
          palette: ['palette6']
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 320
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        labels: this.labelsGroup
      }

      this.chartOptionsOrdersByGroup = newChartOptionsOrdersByGroup
    },

    async getTopOrderedProducts(page, period) {
      if (this.isBusy) {
        return
      }

      this.isBusy = true
      this.updateLoadingProgress('products')
      this.productsLoadingMessage = 'Buscando Top Produtos'
      this.productsLoadingSubtext = 'Montando a lista de mais vendidos...'

      const url = `${config.default.urlBase}/dashboards/landing-page/top-ordered-products/search`
      const params = this.buildParams(page, period)

      try {
        const response = await axios({
          url,
          method: 'GET',
          params,
          headers: {
            authorization: `Bearer ${this.token}`
          },
          timeout: 15000 // Timeout de 15 segundos
        })

        if (response.status == 200) {
          this.items = response.data.items || []
          this.pagination = {
            ...response.data,
            rowsPerPage: this.perPage,
            paginationRange: this.paginationRange
          }
        }
      } catch (error) {
        console.error('Error in getTopOrderedProducts:', error)
        this.handleApiError(error)
        this.items = []
        this.pagination = {}
      } finally {
        this.isBusy = false
        this.productsLoadingMessage = ''
        this.productsLoadingSubtext = ''
      }
    },

    openCheckHelth(url) {
      window.open(url, '_blank')
    },

    async buildParamsSite(companyId, siteId, fantasy) {
      return {
        companyId,
        siteId,
        fantasy
      }
    },

    async closePending() {
      try {
        this.openModalSafely('modalPending', 'modalPending', 'hide')
      } catch (e) {
        // noop
      }
      await this.updateHome(this.currentPage, 0)
    },

    async redirectProductsSite(site) {
      const paramsSite = await this.buildParamsSite(site.companyId, site.siteId, site.fantasy)

      this.$router.push({
        name: 'ProductsSite',
        params: paramsSite
      })
    },

    async buildParamsMonitoringSite(siteId) {
      return {
        siteId
      }
    },

    async redirectMonitoringSite(site) {
      const paramsSite = await this.buildParamsMonitoringSite(site.siteId)

      this.$router.push({
        name: 'Monitoring',
        params: paramsSite
      })
    },

    async openModalPos(posBySite) {
      this.posId = posBySite.id
      this.posNumber = posBySite.number
      this.sitefParams = posBySite.sitefParams
      this.sitefAllowedTransactions = posBySite.sitefAllowedTransactions
      this.sitefOtp = posBySite.sitefOtp

      let selectedItem = this.optionSitefLib.find(item => item.text == posBySite.sitefLib)
      this.selectedSitefLib = selectedItem ? selectedItem.value : 0

      this.sitefExternalCom = posBySite.sitefExternalCom
      this.sitefIsDoubleValidation = posBySite.sitefIsDoubleValidation
      this.timerInteraction = posBySite.timerInteraction

      this.isCollapseOpen = false
      this.sitefDailyToken = ''
      this.allowEditSitef = false

      await this.getWeighingMachine()

      let returnSelectedWeighingMachine
      returnSelectedWeighingMachine = this.optionWeighingMachine.find(option => option.id === posBySite.weighingMachineId)
      this.selectedWeighingMachine = returnSelectedWeighingMachine ? returnSelectedWeighingMachine.value : null

      this.$refs.editPosSite.show()
    },

    async getWeighingMachine() {
      const url = `${config.default.urlBase}/weighing-machine`

      try {
        const response = await axios({
          url,
          method: 'GET',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          response.data

          this.optionWeighingMachine = await Promise.all(
            response.data.map((item, index) => {
              return {
                value: index,
                id: item.id,
                text: `ID: ${item.id} - Tipo: ${item.labelType} - Tamanho Código: ${item.codeSize} - Prefixo: ${item.prefix}`
              }
            })
          )
        }
      } catch (error) {
        console.error('Error in getWeighingMachine:', error)
      }
    },

    buildPosData(
      posId,
      weighingMachineId,
      sitefParams,
      sitefLib,
      sitefExternalCom,
      sitefIsDoubleValidation,
      sitefOtp,
      sitefAllowedTransactions,
      timerInteraction
    ) {
      return {
        posId,
        weighingMachineId,
        sitefParams,
        sitefLib: this.optionSitefLib[sitefLib].text,
        sitefExternalCom,
        sitefIsDoubleValidation,
        sitefOtp,
        sitefAllowedTransactions,
        timerInteraction: timerInteraction ? parseInt(timerInteraction) : 0
      }
    },

    cancelPosConfiguration() {
      this.$refs.editPosSite.hide()
    },

    async confirmPosConfiguration() {
      this.isLoading = true

      const posData = this.buildPosData(
        this.posId,
        this.selectedWeighingMachine != null ? this.optionWeighingMachine[this.selectedWeighingMachine].id : 0,
        this.sitefParams,
        this.selectedSitefLib,
        this.sitefExternalCom,
        this.sitefIsDoubleValidation,
        this.sitefOtp,
        this.sitefAllowedTransactions,
        this.timerInteraction
      )

      try {
        const response = await axios({
          url: `${config.default.urlBase}/sites/pos`,
          method: 'PATCH',
          data: posData,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          this.$refs.editPosSite.hide()

          await this.$alert('Configuração do POS alterada!', 'Sucesso', 'success')

          await this.getDevicesBySiteId(this.selectedSite)
        }
      } catch (error) {
        console.error('Error in confirmPosConfiguration:', error)

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          this.$alert(`Ocorreu um erro ao alterar as configurações do POS! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    clearWeighingMachine() {
      this.selectedWeighingMachine = null
    },

    async alloewdEditionSitef() {
      try {
        if (this.sitefDailyToken != '') {
          const response = await axios({
            url: `${config.default.urlBase}/support/daily/token`,
            method: 'GET',
            headers: {
              authorization: `Bearer ${this.token}`
            }
          })

          if (response.status == 200) {
            this.DailyToken = response.data.token

            if (this.DailyToken === this.sitefDailyToken) {
              this.allowEditSitef = true
            } else if (this.sitefDailyToken !== '') {
              this.allowEditSitef = false

              await this.$alert('Token Incorreto!', 'Aviso', 'warning')
            }
          }
        }
      } catch (error) {
        console.error('Error in alloewdEditionSitef:', error)

        this.allowEditSitef = false
      }
    },

    async getDashboard() {
      if (this.isBusyDashboards) {
        return
      }

      this.isBusyDashboards = true
      this.updateLoadingProgress('dashboard')
      this.dashboardsLoadingMessage = 'Buscando Lojas'
      this.dashboardsLoadingSubtext = 'Coletando status dos servidores locais...'

      const url = `${config.default.urlBase}/dashboards/landing-page`

      try {
        const response = await axios({
          url,
          method: 'GET',
          headers: {
            authorization: `Bearer ${this.token}`
          },
          timeout: 30000
        })

        if (response.status == 200) {
          this.dataDashboard = response.data.sites || []

          this.filteredStores = [...this.dataDashboard]

          this.applySorting()

          this.initializeStorePeriods()

          this.companiesToWebhooks = response.data.companiesToWebhooks || []

          this.totalOrdersNotSent = this.companiesToWebhooks.reduce((accumulator, currentValue) => {
            const pendingRecords = parseInt(currentValue.pendingRecords) || 0
            return accumulator + pendingRecords
          }, 0)

          const totals = response.data.totals || {}
          this.amountOrdersToday = totals.amountOrdersToday || 0
          this.valueOrdersToday = totals.valueOrdersToday || 0
          this.averageTicketToday = totals.averageTicketToday || 0

          this.amountOrdersSevenDays = totals.amountOrdersSevenDays || 0
          this.valueOrdersSevenDays = totals.valueOrdersSevenDays || 0
          this.averageTicketSevenDays = totals.averageTicketSevenDays || 0

          this.amountOrdersThirtyDays = totals.amountOrdersThirtyDays || 0
          this.valueOrdersThirtyDays = totals.valueOrdersThirtyDays || 0
          this.averageTicketThirtyDays = totals.averageTicketThirtyDays || 0
        }
      } catch (error) {
        console.error('Error in getDashboard:', error)
        this.handleApiError(error)
      } finally {
        this.isBusyDashboards = false
        this.dashboardsLoadingMessage = ''
        this.dashboardsLoadingSubtext = ''
        this.publishPosOfflineCount()
        this.publishLocalServerOfflineCount()
      }
    },

    async updateHome(page, period) {
      if (this.isLoading) {
        return
      }

      this.isLoading = true

      const totalPeriod = period == 0 ? 1 : period

      try {
        await Promise.all([
          this.updateChart(totalPeriod),
          this.getDashboard(),
          this.getTopOrderedProducts(page, period),
          this.verifyPartnersPending(),
          this.verifyPartnersCustomerPending()
        ])

        await this.calculateTotalOrdersNotSent(this.totalOrdersNotSent, this.totalPartnersPending, this.totalPartnersCustomerPending)
      } catch (error) {
        console.error('Error in updateHome:', error)
      } finally {
        this.isLoading = false
      }
    },

    async buildDataSendOrders(companyIds) {
      let data = new Object()

      data.companyIds = companyIds

      return data
    },

    async showOrdersNotSentErp() {
      this.checkedCachedCompanies = ''
      this.offlineWebhooks = []
      this.onlineWebhooks = []

      this.isLoading = true

      try {
        const url = `${config.default.urlBase}/stock-management/dead-letter-queue`
        const response = await axios({
          url,
          method: 'GET',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false
          this.ordersNotSent = response.data
        }
      } catch (error) {
        console.error('Error in showOrdersNotSentErp:', error)
      }

      this.$refs.showOrdersNotSentErp.show()

      this.$nextTick(() => {
        // Adiciona animação especial ao ícone quando o modal abre
        const pendingIcon = document.getElementById('pendingIcon1')
        if (pendingIcon) {
          pendingIcon.classList.add('modal-open')

          // Remove a classe após a animação terminar
          setTimeout(() => {
            pendingIcon.classList.remove('modal-open')
          }, 1000)
        }

        this.selectAllRows()
      })
    },

    onRowSelected(companies) {
      this.selectedCompanies = companies

      if (this.selectedCompanies.length > 0) {
        const arrayCompanies = this.selectedCompanies.map(company => company.companyId)
        this.companiesId = new Array(arrayCompanies.join(','))
      } else {
        // Limpar array quando não há seleções
        this.companiesId = []
      }
    },

    onRowSelectedPartners(partners) {
      this.selectedPartners = partners

      if (this.selectedPartners.length > 0) {
        const arrayPartners = this.selectedPartners.map(partner => partner.companyId)
        this.companiesIdPartners = new Array(arrayPartners.join(','))
      } else {
        // Limpar array quando não há seleções
        this.companiesIdPartners = []
      }
    },

    onRowSelectedPartnersCustomer(partners) {
      this.selectedPartnersCustomer = partners

      if (this.selectedPartnersCustomer.length > 0) {
        const arrayPartners = this.selectedPartnersCustomer.map(partner => partner.companyId)
        this.companiesIdPartnersCustomer = new Array(arrayPartners.join(','))
      } else {
        // Limpar array quando não há seleções
        this.companiesIdPartnersCustomer = []
      }
    },

    async forceOrdersNotSentErp() {
      if (!this.companiesId || this.companiesId.length === 0) {
        await this.getNotification('Aviso', 'Selecione pelo menos uma empresa para enviar as pendências', 'warning')
        return
      }

      if (!Array.isArray(this.companiesId) || this.companiesId.some(id => !id || id === '')) {
        await this.getNotification('Erro', 'Dados de empresas selecionadas inválidos. Selecione novamente as empresas.', 'error')
        return
      }

      this.startPendingOperation('orders')
      this.updatePendingProgress(10, 'Preparando dados para envio...')

      const url = `${config.default.urlBase}/stock-management/dead-letter-queue/send-to-sqs`

      try {
        this.updatePendingProgress(30, 'Construindo dados de envio...')
        const data = await this.buildDataSendOrders(this.companiesId)

        this.updatePendingProgress(50, 'Enviando pendências para o sistema...')
        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        this.checkedCachedCompanies = response.data.checkedCachedCompanies
        this.offlineWebhooks = response.data.offlineWebhooks
        this.onlineWebhooks = response.data.onlineWebhooks

        if (response.status == 200) {
          this.updatePendingProgress(90, 'Finalizando operação...')
          this.totalOrdersNotSent = 0

          await this.$refs.showOrdersNotSentErp.hide()

          if (response.message != '') {
            this.messageSendOrders = `${response.data.message}`

            this.$router.push({
              path: '/stock-backlogs',
              query: {
                checkedCachedCompanies: this.checkedCachedCompanies,
                offlineWebhooks: JSON.stringify(this.offlineWebhooks),
                onlineWebhooks: JSON.stringify(this.onlineWebhooks),
                counter: response.data.counter
              }
            })
          } else {
            await this.getNotification('Operação concluída', 'Comando enviado com sucesso!', 'success')
          }

          this.completePendingOperation()
        }
      } catch (error) {
        console.error('Error in forceOrdersNotSentErp:', error)

        if (error.response && error.response.status == 420) {
          this.messageSendOrders = `${error.response.data}`
          this.$refs.sendOrders.show()
        } else {
          this.messageSendOrders = `${error.response?.data || 'Erro ao enviar pendências'}`
          this.$refs.sendOrders.show()
        }

        this.completePendingOperation()
        await this.updateHome(this.currentPage, 0)
      }
    },

    async forcePartnersPending() {
      // Validação: verificar se há empresas selecionadas
      if (!this.companiesIdPartners || this.companiesIdPartners.length === 0) {
        await this.getNotification('Aviso', 'Selecione pelo menos uma empresa para enviar as pendências de estoque', 'warning')
        return
      }

      // Validação adicional: verificar se os dados são válidos
      if (!Array.isArray(this.companiesIdPartners) || this.companiesIdPartners.some(id => !id || id === '')) {
        await this.getNotification('Erro', 'Dados de empresas selecionadas inválidos. Selecione novamente as empresas.', 'error')
        return
      }

      this.startPendingOperation('stock')
      this.updatePendingProgress(10, 'Preparando dados de estoque para envio...')

      try {
        const url = `${config.default.urlBase}/partners/dead-letter-queue/send-to-sqs`

        this.updatePendingProgress(30, 'Construindo dados de envio...')
        const data = await this.buildDataSendPartnersPending(this.companiesIdPartners)

        this.updatePendingProgress(50, 'Enviando pendências de estoque para o sistema...')
        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        this.checkedCachedCompanies = response.data.checkedCachedCompanies
        this.offlineWebhooks = response.data.offlineWebhooks || []
        this.onlineWebhooks = response.data.onlineWebhooks || []

        this.completePendingOperation()

        await this.loadPartnersPendingData()

        const stillHasStockPending = this.totalPartnersPending > 0

        if (!stillHasStockPending) {
          await this.getNotification('Operação concluída', 'Pendências de estoque enviadas com sucesso!', 'success')
        }
      } catch (error) {
        console.error('Error in forcePartnersPending:', error)

        if (error.response && error.response.status == 420) {
          this.messageSendOrders = `${error.response.data}`
          this.$refs.sendOrders.show()
        } else {
          this.messageSendOrders = `${error.response?.data || 'Erro ao enviar pendências de estoque'}`
          this.$refs.sendOrders.show()
        }

        this.completePendingOperation()
        await this.updateHome(this.currentPage, 0)
      }
    },

    async forcePartnersCustomerPending() {
      // Validação: verificar se há empresas selecionadas
      if (!this.companiesIdPartnersCustomer || this.companiesIdPartnersCustomer.length === 0) {
        await this.getNotification('Aviso', 'Selecione pelo menos uma empresa para enviar as pendências de clientes', 'warning')
        return
      }

      // Validação adicional: verificar se os dados são válidos
      if (!Array.isArray(this.companiesIdPartnersCustomer) || this.companiesIdPartnersCustomer.some(id => !id || id === '')) {
        await this.getNotification('Erro', 'Dados de empresas selecionadas inválidos. Selecione novamente as empresas.', 'error')
        return
      }

      this.startPendingOperation('customers')
      this.updatePendingProgress(10, 'Preparando dados de clientes para envio...')

      try {
        const url = `${config.default.urlBase}/partners/customers/dead-letter-queue/send-to-sqs`

        this.updatePendingProgress(30, 'Construindo dados de envio...')
        const data = await this.buildDataSendPartnersPending(this.companiesIdPartnersCustomer)

        this.updatePendingProgress(50, 'Enviando pendências de clientes para o sistema...')
        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        this.checkedCachedCompanies = response.data.checkedCachedCompanies
        this.offlineWebhooks = response.data.offlineWebhooks
        this.onlineWebhooks = response.data.onlineWebhooks
        this.totalSent = response.data.counter

        if (response.status == 200) {
          this.updatePendingProgress(90, 'Finalizando operação de clientes...')
          this.totalPartnersCustomerPending = 0

          this.$refs.partnersPendingModal.hide()

          if (this.checkedCachedCompanies != '') {
            await this.getNotification('Operação concluída', 'Pendências de clientes enviadas com sucesso!', 'success')
          } else {
            await this.getNotification('Operação concluída', 'Comando enviado com sucesso!', 'success')
          }

          this.completePendingOperation()

          // Recarregar os dados das pendências para atualizar o card
          await this.loadPartnersPendingData()

          // Verificar se ainda existem pendências após o envio
          const stillHasCustomerPending = this.totalPartnersCustomerPending > 0

          // Se não há mais pendências, mostrar notificação
          if (!stillHasCustomerPending) {
            await this.getNotification('Operação concluída', 'Todas as pendências de clientes foram enviadas com sucesso!', 'success')
          }
        }
      } catch (error) {
        console.error('Error in forcePartnersCustomerPending:', error)

        if (error.response && error.response.status == 420) {
          this.messageSendOrders = `${error.response.data}`
          this.$refs.sendOrders.show()
        } else {
          this.messageSendOrders = `${error.response?.data || 'Erro ao enviar pendências de clientes'}`
          this.$refs.sendOrders.show()
        }

        this.completePendingOperation()
        await this.updateHome(this.currentPage, 0)
      }
    },

    async forceAllPartnersPending() {
      // Validação: verificar se há empresas selecionadas
      let hasStockPending = this.companiesIdPartners && this.companiesIdPartners.length > 0
      let hasCustomerPending = this.companiesIdPartnersCustomer && this.companiesIdPartnersCustomer.length > 0

      if (!hasStockPending && !hasCustomerPending) {
        await this.getNotification('Aviso', 'Selecione pelo menos uma empresa para enviar as pendências', 'warning')
        return
      }

      // Validação adicional: verificar se os dados são válidos
      if (hasStockPending && (!Array.isArray(this.companiesIdPartners) || this.companiesIdPartners.some(id => !id || id === ''))) {
        await this.getNotification('Erro', 'Dados de empresas selecionadas para estoque inválidos. Selecione novamente as empresas.', 'error')
        return
      }

      if (hasCustomerPending && (!Array.isArray(this.companiesIdPartnersCustomer) || this.companiesIdPartnersCustomer.some(id => !id || id === ''))) {
        await this.getNotification('Erro', 'Dados de empresas selecionadas para clientes inválidos. Selecione novamente as empresas.', 'error')
        return
      }

      this.startPendingOperation('all')
      this.updatePendingProgress(5, 'Iniciando envio de todas as pendências...')

      try {
        let totalSteps = 0
        if (hasStockPending) totalSteps++
        if (hasCustomerPending) totalSteps++

        let currentStep = 0

        if (hasStockPending) {
          currentStep++
          this.updatePendingProgress(20 + currentStep * 30, `Enviando pendências de estoque (${currentStep}/${totalSteps})...`)

          const stockUrl = `${config.default.urlBase}/partners/dead-letter-queue/send-to-sqs`
          const stockData = await this.buildDataSendPartnersPending(this.companiesIdPartners)

          await axios({
            url: stockUrl,
            method: 'POST',
            data: stockData,
            headers: {
              authorization: `Bearer ${this.token}`
            }
          })
        }

        if (hasCustomerPending) {
          currentStep++
          this.updatePendingProgress(20 + currentStep * 30, `Enviando pendências de clientes (${currentStep}/${totalSteps})...`)

          const customerUrl = `${config.default.urlBase}/partners/customers/dead-letter-queue/send-to-sqs`
          const customerData = await this.buildDataSendPartnersPending(this.companiesIdPartnersCustomer)

          await axios({
            url: customerUrl,
            method: 'POST',
            data: customerData,
            headers: {
              authorization: `Bearer ${this.token}`
            }
          })
        }

        this.updatePendingProgress(90, 'Finalizando operação...')

        this.$refs.partnersPendingModal.hide()

        let message = 'Pendências enviadas com sucesso!'
        if (hasStockPending && hasCustomerPending) {
          message = 'Todas as pendências (estoque e clientes) foram enviadas com sucesso!'
        } else if (hasStockPending) {
          message = 'Pendências de estoque foram enviadas com sucesso!'
        } else if (hasCustomerPending) {
          message = 'Pendências de clientes foram enviadas com sucesso!'
        }

        await this.getNotification('Operação concluída', message, 'success')

        this.selectedPartners = []

        await this.updateHome(this.currentPage, 0)
        await this.loadPartnersPendingData()

        const stillHasStockPending = this.totalPartnersPending > 0
        const stillHasCustomerPending = this.totalPartnersCustomerPending > 0
        const stillHasAnyPending = stillHasStockPending || stillHasCustomerPending

        this.completePendingOperation()

        if (!stillHasAnyPending) {
          await this.getNotification('Operação concluída', 'Todas as pendências foram enviadas com sucesso!', 'success')
        }
      } catch (error) {
        console.error('Error in forceAllPartnersPending:', error)

        let errorMessage = 'Erro ao enviar pendências'
        if (error.response && error.response.data) {
          errorMessage = error.response.data
        }

        this.completePendingOperation()
        await this.getNotification('Erro', errorMessage, 'error')
        await this.updateHome(this.currentPage, 0)
      }
    },

    startPendingOperation(operation) {
      this.isSendingPending = true
      this.pendingOperation = operation
      this.pendingProgress = 0
      this.pendingStartTime = Date.now()
      this.pendingElapsedTime = 0
      this.pendingStatus = 'Iniciando operação...'

      if (operation === 'orders') this.pendingOperations.orders = true
      else if (operation === 'stock') this.pendingOperations.stock = true
      else if (operation === 'customers') this.pendingOperations.customers = true
      else if (operation === 'all') this.pendingOperations.all = true

      this.pendingTimer = setInterval(() => {
        this.pendingElapsedTime = Date.now() - this.pendingStartTime
      }, 100)
    },

    updatePendingProgress(progress, status) {
      this.pendingProgress = Math.min(progress, 100)
      this.pendingStatus = status
    },

    completePendingOperation() {
      this.isSendingPending = false
      this.pendingProgress = 100
      this.pendingStatus = 'Operação concluída!'

      this.pendingOperations.orders = false
      this.pendingOperations.stock = false
      this.pendingOperations.customers = false
      this.pendingOperations.all = false

      if (this.pendingTimer) {
        clearInterval(this.pendingTimer)
        this.pendingTimer = null
      }

      setTimeout(() => {
        this.pendingProgress = 0
        this.pendingStatus = ''
        this.pendingOperation = ''
        this.pendingElapsedTime = 0
      }, 2000)
    },

    formatElapsedTime(milliseconds) {
      const seconds = Math.floor(milliseconds / 1000)
      const minutes = Math.floor(seconds / 60)
      const hours = Math.floor(minutes / 60)

      if (hours > 0) {
        return `${hours}h ${minutes % 60}m ${seconds % 60}s`
      } else if (minutes > 0) {
        return `${minutes}m ${seconds % 60}s`
      } else {
        return `${seconds}s`
      }
    },

    getPendingButtonText(operation) {
      if (this.isSendingPending && this.pendingOperations[operation]) {
        return 'Enviando...'
      }

      switch (operation) {
        case 'orders':
          return 'Enviar selecionados'
        case 'stock':
          return 'Enviar selecionados'
        case 'customers':
          return 'Enviar selecionados'
        case 'all':
          return 'Enviar Todas as Pendências'
        default:
          return 'Enviar'
      }
    },

    isPendingOperationActive(operation) {
      return this.isSendingPending && this.pendingOperations[operation]
    },

    lockSitefEdition() {
      if (this.allowEditSitef) {
        this.allowEditSitef = false
      }
    },

    showPasswordSitefConfiguration() {
      this.showPasswordSitef = !this.showPasswordSitef

      if (this.showPasswordSitef) {
        this.typeInput = 'text'
      } else {
        this.typeInput = 'password'
      }

      this.focus('sitefDailyToken')
    },

    focus(id) {
      document.getElementById(id).focus()
    },

    async verifyPartnersPending() {
      if (this.isVerifyingPartners) {
        return
      }

      this.isVerifyingPartners = true
      this.updateLoadingProgress('partners')
      this.partnersLoadingMessage = 'Buscando Pendências de Parceiros'
      this.partnersLoadingSubtext = 'Verificando pendências de estoque ...'

      try {
        const url = `${config.default.urlBase}/partners/dead-letter-queue`

        const response = await axios({
          url,
          method: 'GET',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.companiesPartnersPending = response.data || []

          this.checkedCachedCompanies = response.data.checkedCachedCompanies || ''
          this.offlineWebhooks = response.data.offlineWebhooks || []
          this.onlineWebhooks = response.data.onlineWebhooks || []
          this.totalSent = response.data.counter || 0

          this.totalPartnersPending = this.companiesPartnersPending.reduce((accumulator, currentValue) => {
            const counter = parseInt(currentValue.counter) || 0
            return accumulator + counter
          }, 0)
        }
      } catch (error) {
        console.error('Error in verifyPartnersPending:', error)
      } finally {
        this.isVerifyingPartners = false
        this.partnersLoadingMessage = ''
        this.partnersLoadingSubtext = ''
      }
    },

    selectAllRowsPartnersCustomer() {
      if (this.$refs.selectableCompaniesPartnersCustomer && typeof this.$refs.selectableCompaniesPartnersCustomer.selectAllRows === 'function') {
        this.$refs.selectableCompaniesPartnersCustomer.selectAllRows()
      }
    },

    clearSelectedPartnersCustomer() {
      this.$refs.selectableCompaniesPartnersCustomer.clearSelected()
    },

    async verifyPartnersCustomerPending() {
      // Evitar chamadas simultâneas
      if (this.isVerifyingPartnersCustomer) {
        return
      }

      this.isVerifyingPartnersCustomer = true
      this.updateLoadingProgress('partners')
      this.partnersCustomerLoadingMessage = 'Buscando Pendências de Parceiros'
      this.partnersCustomerLoadingSubtext = 'Verificando pendências de clientes...'

      try {
        const url = `${config.default.urlBase}/partners/customers/dead-letter-queue`

        const response = await axios({
          url,
          method: 'GET',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.companiesPartnersCustomerPending = response.data || []

          this.totalPartnersCustomerPending = this.companiesPartnersCustomerPending.reduce((accumulator, currentValue) => {
            const counter = parseInt(currentValue.counter) || 0
            return accumulator + counter
          }, 0)

          // Forçar atualização da interface
          this.$nextTick(() => {
            this.$forceUpdate()
          })
        }
      } catch (error) {
        console.error('Error in verifyPartnersCustomerPending:', error)

        // Adicionar tratamento específico para diferentes tipos de erro
        if (error.response) {
          if (error.response.status === 403) {
            await this.getNotification('Aviso', 'Sem permissão para acessar pendências de clientes', 'warning')
          }
        } else if (error.request) {
          await this.getNotification('Erro', 'Erro de rede ao buscar pendências de clientes', 'error')
        }
      } finally {
        this.isVerifyingPartnersCustomer = false
        this.partnersCustomerLoadingMessage = ''
        this.partnersCustomerLoadingSubtext = ''
      }
    },

    async calculateTotalOrdersNotSent(totalOrdersNotSent, totalPartnersPending, totalPartnersCustomerPending) {
      this.totalPending = totalOrdersNotSent + totalPartnersPending + totalPartnersCustomerPending
      this.allPartnersPending = totalPartnersPending + totalPartnersCustomerPending
      // Atualizar publicação para Navbar
      this.publishTotalPendingCount()
    },

    async loadPartnersPendingData() {
      try {
        // Recarregar dados de estoque
        await this.verifyPartnersPending()

        // Recarregar dados de clientes
        await this.verifyPartnersCustomerPending()

        // Recalcular totais
        await this.calculateTotalOrdersNotSent(this.totalOrdersNotSent, this.totalPartnersPending, this.totalPartnersCustomerPending)
      } catch (error) {
        console.error('Error loading partners pending data:', error)
      }
    },

    showPartnersPending() {
      this.partnersTabIndex = 0
      this.checkedCachedCompanies = ''
      this.offlineWebhooks = []
      this.onlineWebhooks = []

      this.$refs.partnersPendingModal.show()

      this.$nextTick(async () => {
        // Adiciona animação especial ao ícone quando o modal abre
        const pendingIcon = document.getElementById('pendingIcon2')
        if (pendingIcon) {
          pendingIcon.classList.add('modal-open')

          // Remove a classe após a animação terminar
          setTimeout(() => {
            pendingIcon.classList.remove('modal-open')
          }, 1000)
        }

        // Carregar dados das pendências quando o modal abrir
        await this.loadPartnersPendingData()

        this.selectAllRowsPartners()
        this.selectAllRowsPartnersCustomer()
      })
    },

    showPendings() {
      this.openModalSafely('modalPending', 'modalPending', 'show')
    },

    async getPermissions() {
      let permissions = sessionStorage.getItem('permissions')

      if (!permissions) {
        permissions = sessionStorage.getItem('permissions')
      }

      this.permissions = await JSON.parse(permissions)
      await this.mapUserPermissions(this.permissions)
    },

    async mapUserPermissions(permissions) {
      const commands = permissions.filter(item => item.command).map(item => item.command)
      this.userPermissions = commands
    },

    alertPermission() {
      this.getNotification('Atenção', 'Verifique permissões do usuário!', 'warning')
    },

    selectPeriod(storeIndex, period) {
      if (!this.storePeriods[storeIndex]) {
        this.storePeriods[storeIndex] = {}
      }

      if (this.storePeriods[storeIndex].selected === period || this.isBusyCharts) {
        return
      }

      this.storePeriods[storeIndex].selected = period

      this.$forceUpdate()
    },

    nextStorePage() {
      if (this.currentStorePage < this.totalStorePages) {
        this.currentStorePage++
        this.resetStorePeriods()
      }
    },

    previousStorePage() {
      if (this.currentStorePage > 1) {
        this.currentStorePage--
        this.resetStorePeriods()
      }
    },

    resetStorePeriods() {
      this.$nextTick(() => {
        for (let i = 0; i < this.storesPerPage; i++) {
          if (!this.storePeriods[i]) {
            this.storePeriods[i] = {}
          }
          this.storePeriods[i].selected = 'today'
        }
      })
    },

    getPeriodLabel(storeIndex) {
      const storePeriod = this.storePeriods[storeIndex]
      const period = storePeriod && storePeriod.selected ? storePeriod.selected : 'today'

      switch (period) {
        case 'today':
          return 'Hoje'
        case '7days':
          return '7 Dias'
        case '30days':
          return '30 Dias'
        default:
          return 'Hoje'
      }
    },

    getPeriodQuantity(storeIndex) {
      const storePeriod = this.storePeriods[storeIndex]
      const period = storePeriod && storePeriod.selected ? storePeriod.selected : 'today'

      const store = this.paginatedStores[storeIndex]

      if (!store) return '0'

      let value
      switch (period) {
        case 'today':
          value = store.amountOrdersToday
          break
        case '7days':
          value = store.amountOrdersSevenDays
          break
        case '30days':
          value = store.amountOrdersThirtyDays
          break
        default:
          value = store.amountOrdersToday
          break
      }

      if (value === null || value === undefined || value === '' || isNaN(parseFloat(value))) {
        return '0'
      }

      return value.toString()
    },

    getPeriodValue(storeIndex) {
      const storePeriod = this.storePeriods[storeIndex]
      const period = storePeriod && storePeriod.selected ? storePeriod.selected : 'today'

      const store = this.paginatedStores[storeIndex]

      if (!store) return 'R$ 0,00'

      let value
      switch (period) {
        case 'today':
          value = store.valueOrdersToday
          break
        case '7days':
          value = store.valueOrdersSevenDays
          break
        case '30days':
          value = store.valueOrdersThirtyDays
          break
        default:
          value = store.valueOrdersToday
          break
      }

      if (value === null || value === undefined || value === '') {
        return 'R$ 0,00'
      }

      if (typeof value === 'string' && value.startsWith('R$')) {
        return value
      }

      const numericValue = parseFloat(value)
      if (isNaN(numericValue)) {
        return 'R$ 0,00'
      }

      return `R$ ${numericValue.toFixed(2).replace('.', ',')}`
    },

    setCurrentPeriod(period) {
      if (this.currentPeriod === period || this.isBusyCharts) {
        return
      }
      this.currentPeriod = period
      this.getDataChart(this.getPeriodValueForChart(period))
    },

    getCurrentPeriodLabel() {
      switch (this.currentPeriod) {
        case 'today':
          return 'Hoje'
        case '7days':
          return '7 Dias'
        case '30days':
          return '30 Dias'
        default:
          return 'Hoje'
      }
    },

    getPeriodValueForChart(period) {
      switch (period) {
        case 'today':
          return 0
        case '7days':
          return 7
        case '30days':
          return 30
        default:
          return 0
      }
    },

    getTotalQuantity() {
      let value
      switch (this.currentPeriod) {
        case 'today':
          value = this.amountOrdersToday
          break
        case '7days':
          value = this.amountOrdersSevenDays
          break
        case '30days':
          value = this.amountOrdersThirtyDays
          break
        default:
          value = this.amountOrdersToday
          break
      }

      if (value === null || value === undefined || value === '' || isNaN(parseFloat(value))) {
        return '0'
      }

      return value.toString()
    },

    getTotalValue() {
      let value
      switch (this.currentPeriod) {
        case 'today':
          value = this.valueOrdersToday
          break
        case '7days':
          value = this.valueOrdersSevenDays
          break
        case '30days':
          value = this.valueOrdersThirtyDays
          break
        default:
          value = this.valueOrdersToday
          break
      }

      if (value === null || value === undefined || value === '') {
        return 'R$ 0,00'
      }

      if (typeof value === 'string' && value.startsWith('R$')) {
        return value
      }

      const numericValue = parseFloat(value)
      if (isNaN(numericValue)) {
        return 'R$ 0,00'
      }

      return `R$ ${numericValue.toFixed(2).replace('.', ',')}`
    },

    getAverageTicket() {
      let value
      switch (this.currentPeriod) {
        case 'today':
          value = this.averageTicketToday
          break
        case '7days':
          value = this.averageTicketSevenDays
          break
        case '30days':
          value = this.averageTicketThirtyDays
          break
        default:
          value = this.averageTicketToday
          break
      }

      // Validar se o valor é válido
      if (value === null || value === undefined || value === '') {
        return 'R$ 0,00'
      }

      // Se o valor já vem formatado (ex: 'R$ 26,41'), retornar diretamente
      if (typeof value === 'string' && value.startsWith('R$')) {
        return value
      }

      // Se for um número, formatar
      const numericValue = parseFloat(value)
      if (isNaN(numericValue)) {
        return 'R$ 0,00'
      }

      return `R$ ${numericValue.toFixed(2).replace('.', ',')}`
    },

    initializeStorePeriods() {
      this.filteredStores.forEach((store, index) => {
        if (!this.storePeriods[index]) {
          this.storePeriods[index] = {}
        }
        this.storePeriods[index].selected = 'today'
      })
    },

    updatePeriodsAfterSorting() {
      this.storePeriods = {}

      this.filteredStores.forEach((store, index) => {
        this.storePeriods[index] = {
          selected: 'today'
        }
      })

      this.$forceUpdate()
    },

    async buildDataSendPartnersPending(companyIds) {
      let data = new Object()

      data.companyIds = companyIds

      return data
    }
  },

  updated() {},

  watch: {},

  beforeDestroy() {},

  destroyed() {
    this._mounted = false
  },

  async mounted() {
    if (this._mounted) {
      return
    }

    this._mounted = true

    // Verificar se o token está disponível
    if (!this.token) {
      console.error('Token não encontrado!')
      return
    }

    try {
      await this.loadAllDataParallel()

      if (!this.filteredStores || this.filteredStores.length === 0) {
        this.filteredStores = [...this.dataDashboard]
        this.applySorting()
      }

      try {
        const forcedSort = localStorage.getItem('homeSortOption')
        if (forcedSort === 'site_offline' || forcedSort === 'server_offline') {
          this.storeSortOption = forcedSort
          this.applySorting()
          localStorage.removeItem('homeSortOption')
        }

        const openPending = localStorage.getItem('homeOpenPending')
        if (openPending === '1') {
          localStorage.removeItem('homeOpenPending')
          this.showPendings()
        }
      } catch (e) {
        // noop
      }

      if (typeof window !== 'undefined') {
        window.addEventListener('home-open-pending', () => {
          this.showPendings()
        })

        window.addEventListener('home-apply-sort', e => {
          try {
            const sort = e && e.detail ? String(e.detail) : null
            if (sort === 'site_offline' || sort === 'server_offline') {
              this.storeSortOption = sort
              this.applySorting()
            }
          } catch (err) {
            // noop
          }
        })
      }

      await this.showInitialNotificationsHint()
    } catch (error) {
      console.error('Erro durante o carregamento:', error)
    }
  },

  created() {},

  async beforeMount() {
    this.token = sessionStorage.getItem('token')

    if (!this.token) {
      this.token = sessionStorage.getItem('token')
    }

    this.series = []
    this.seriesGroup = []

    await this.getPermissions()

    try {
      const forcedSort = localStorage.getItem('homeSortOption')
      if (forcedSort === 'site_offline' || forcedSort === 'server_offline') {
        this.storeSortOption = forcedSort
      }
    } catch (e) {
      // noop
    }
  },

  computed: {
    totalStorePages() {
      return Math.ceil(this.filteredStores.length / this.storesPerPage)
    },

    paginatedStores() {
      const start = (this.currentStorePage - 1) * this.storesPerPage
      const end = start + this.storesPerPage
      return this.filteredStores.slice(start, end)
    },

    hasPendingItems() {
      const hasPending = this.totalPartnersPending > 0 || this.totalOrdersNotSent > 0
      return hasPending
    },

    pendingMessage() {
      if (this.totalPending === 1) {
        return 'Existe 1 Pendência.'
      }
      return `Existem ${this.totalPending} Pendências.`
    },

    hasMonitoringPermission() {
      return this.userPermissions.includes('monitoring')
    },

    hasSalesListPermission() {
      return this.userPermissions.includes('sales_list')
    },

    hasProductsSiteListPermission() {
      return this.userPermissions.includes('products_site')
    },

    hasStockCustomerPendingAlert() {
      return this.userPermissions.includes('pending_stock_customer_alert')
    },

    hasDashboardPermission() {
      return this.userPermissions.includes('dashboard')
    }
  }
}
